import script from "./PostPurchaseComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PostPurchaseComponent.vue?vue&type=script&setup=true&lang=js"

import "./PostPurchaseComponent.vue?vue&type=style&index=0&id=63791a3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63791a3e"]])

export default __exports__